
import React from 'react';
import './TableQuizes.scss';
import { idQuestionsLoad, getIdSelectedQuize, 
    openInputFormsForQuizes, openDeleteInputFormsForQuizes, openInputFormsForNote, idNoteLoad, setInitialStateQuestions  } from '../../../../adminSlice.js';

export default class TableQuizes extends React.Component {
    constructor(props) {
        super(props);

        this.onGetQuestions = this.onGetQuestions.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onNote = this.onNote.bind(this);
    }

   //GET SUBCATEGORY BY ID
 
onGetQuestions(e) {
    const { dispatch } = this.props;
    //console.log(this.props.adminState.dataQuizes);
    const id= e.target.value ;
    
   // console.log(id);

    dispatch(idQuestionsLoad(id));
    dispatch(getIdSelectedQuize(id));
    dispatch(setInitialStateQuestions())
    this.props.onClickQuiz();
}
onEdit(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    //console.log(id);
    dispatch(openInputFormsForQuizes(id));

}
onDelete(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openDeleteInputFormsForQuizes(id));

}


onNote(e) {
    const { dispatch } = this.props;

    const idQuiz = e.target.value;
    const data = this.props.data;
// LOAD NOTE BY ID
dispatch(idNoteLoad(idQuiz));

//FIND QUIZ BY ID
    const quizData = data.find(item => {
    return item.id === Number(idQuiz);
        })

    const item = {
        id: quizData.id,
        nameQuiz: quizData.text
    }

    this.props.handleAdminQuizesView();
    dispatch(openInputFormsForNote(item));
}


   renderTable() {
    let  data =  this.props.data;
    return (
        data.map(item => {
           // console.log(item.id + " " + item.label);
            return(
                
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                        <div className='content'>
                            <button className='bigbtn'
                            onClick={this.onGetQuestions}
                            value={item.id}
                            >{item.text}<p className='public-item'>{item.public ? "public":""}</p></button>
                            {<p>{item.quiz_description}</p>}


                        </div>
                        
                         <div className='edit'>
                         <button className='smallbtnEdit' value={item.id} onClick={this.onEdit} ></button>
                         <button className='smallbtnDelete' value={item.id} onClick={this.onDelete}></button>
                         <button className='smallbtnTrouble' value={item.id} ></button>
                         <button className='smallbtnNote' value={item.id} onClick={this.onNote} ></button>
                         </div>
                         </td>
                    </tr>
                    
                

                )
            })
        )    
   }
   
    render() {

      //  const data = this.props.data;

        return(
            <div className="TableQuizes">
                
                <table>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Название теста</th>
                        </tr>
                        
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    
                    
                    </tbody>
                
                    
                    

                </table>
                
            </div>
        )
    }
}